import { Client, PrivMsgEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType, tabType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import MessageHandler from '#/messageHandler';
import TabManager from '#/ui/tabManager';

export class PrivMsgEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }
    private setup(): void {
        this.client.on(IRC_EVENT.PRIVMSG, (event: PrivMsgEvent) => {
            const { from_server, nick, ident, hostname, target, group, message, tags, time, account, batch } = event;
            if (target && target.startsWith('#')) {
                const channelTab = this.tM.getTab(tabType.CHANNEL, target) ?? this.tM.getStatusTab();
                this.mH.addMessage(channelTab, message, IRCMessageType.DEFAULT, nick ? nick : hostname);
            } else {
                if (nick) {
                    let queryTab = this.tM.getTab(tabType.QUERY, nick);
                    if (!queryTab) {
                        queryTab = this.tM.addTab(tabType.QUERY, nick);
                    }
                    this.mH.addMessage(queryTab, message, IRCMessageType.DEFAULT, nick ? nick : hostname);
                }
            }
        });
    }
}